// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-management-stop-initiation-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  padding: 48px;
  align-items: center;
  justify-content: center;
}

.form-management-stop-initiation-modal {
  width: 100%;
  max-width: 674px !important;
  min-height: 400px;
  background-color: #fff !important;
  z-index: 9;
}
.form-management-stop-initiation-modal .modal-header .title {
  display: flex;
  gap: 16px;
  align-items: center;
}
.form-management-stop-initiation-modal .modal-body .form-control-radio .radiobutton-label {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--secondary-text, #667085);
}
.form-management-stop-initiation-modal .modal-body .form-control-radio.disabled {
  opacity: 0.2;
  pointer-events: none;
  cursor: default;
}
.form-management-stop-initiation-modal .stop-initiation-button {
  height: 44px;
  display: inline-flex;
  gap: 8px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  color: #ffffff;
  outline: none;
  background-color: var(--tertiary-600, #B42318);
  border: 1px solid var(--secondary-input-outline, #FDA29B);
  cursor: pointer;
}
.form-management-stop-initiation-modal .stop-initiation-button:disabled {
  pointer-events: none;
  background-color: #ffffff;
  color: var(--tertiary-600, #B42318);
}
.form-management-stop-initiation-modal .stop-initiation-button:disabled .icon-icon-x {
  border-color: var(--tertiary-600, #B42318);
}
.form-management-stop-initiation-modal .stop-initiation-button:not(:disabled):hover {
  background-color: #ffffff;
  color: var(--tertiary-600, #B42318);
}
.form-management-stop-initiation-modal .stop-initiation-button:not(:disabled):hover .icon-icon-x {
  border-color: var(--tertiary-600, #B42318);
}
.form-management-stop-initiation-modal .stop-initiation-button .icon-icon-x {
  width: 16px;
  height: 16px;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid #FFFFFF;
}
.form-management-stop-initiation-modal .stop-initiation-button span {
  margin-top: -1px;
}`, "",{"version":3,"sources":["webpack://./src/components/library/form-management-modal/components/stop-initiation-modal/styles.scss"],"names":[],"mappings":"AAAA;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,iCAAA;EACA,UAAA;AACF;AAEI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAMM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;AAJR;AAOM;EACE,YAAA;EACA,oBAAA;EACA,eAAA;AALR;AAUE;EACE,YAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,8CAAA;EACA,yDAAA;EACA,eAAA;AARJ;AAUI;EACE,oBAAA;EACA,yBAAA;EACA,mCAAA;AARN;AAUM;EACE,0CAAA;AARR;AAaM;EACE,yBAAA;EACA,mCAAA;AAXR;AAaQ;EACE,0CAAA;AAXV;AAgBI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAdN;AAiBI;EACE,gBAAA;AAfN","sourcesContent":[".form-management-stop-initiation-modal-overlay {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  display: flex;\n  padding: 48px;\n  align-items: center;\n  justify-content: center;\n}\n\n.form-management-stop-initiation-modal {\n  width: 100%;\n  max-width: 674px !important;\n  min-height: 400px;\n  background-color: #fff !important;\n  z-index: 9;\n\n  .modal-header {\n    .title {\n      display: flex;\n      gap: 16px;\n      align-items: center;\n    }\n  }\n\n  .modal-body {\n    .form-control-radio {\n      .radiobutton-label {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        color: var(--secondary-text, #667085);\n      }\n\n      &.disabled {\n        opacity: .2;\n        pointer-events: none;\n        cursor: default;\n      }\n    }\n  }\n\n  .stop-initiation-button {\n    height: 44px;\n    display: inline-flex;\n    gap: 8px;\n    padding: 0 10px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    align-items: center;\n    justify-content: center;\n    user-select: none;\n    color: #ffffff;\n    outline: none;\n    background-color: var(--tertiary-600, #B42318);\n    border: 1px solid var(--secondary-input-outline, #FDA29B);\n    cursor: pointer;\n\n    &:disabled {\n      pointer-events: none;\n      background-color: #ffffff;\n      color: var(--tertiary-600, #B42318);\n\n      .icon-icon-x {\n        border-color: var(--tertiary-600, #B42318);\n      }\n    }\n\n    &:not(:disabled) {\n      &:hover {\n        background-color: #ffffff;\n        color: var(--tertiary-600, #B42318);\n\n        .icon-icon-x {\n          border-color: var(--tertiary-600, #B42318);\n        }\n      }\n    }\n\n    .icon-icon-x {\n      width: 16px;\n      height: 16px;\n      display: inline-flex;\n      font-size: 10px;\n      font-weight: 600;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n      border: 1px solid #FFFFFF;\n    }\n\n    span {\n      margin-top: -1px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
